import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import classnames from 'classnames';

import StatusSelectDropdown from '../../DropdownMenu/CampaignMode';

import './index.scss';

const getStatusText = (status) => {
  switch (status) {
    case 'IN_PROGRESS': return { dropdown: { edit: false, delete: false, report: true }, value: 'Sending campaign...', showdropdown: false };
      break;
    case 'PUBLISHED': return { dropdown: { edit: false, delete: false, report: true }, value: 'Published', showdropdown: true };
      break;
    case 'CREATED': return { dropdown: { edit: true, delete: true, report: false }, value: 'Created', showdropdown: true };
      break;
    default: return { dropdown: { edit: false, delete: false, report: false }, value: 'status unknows', showdropdown: false };
  }
};

const Campaign = ({ timezone, campaign, editCampaign, deleteCampaign, downloadReport }) => {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  function useOutsideAlerter(ref) {
    /**
     * Alert if clicked on outside of element
     */

    function handleClickOutside(event) {
      if ((ref.current && !ref.current.contains(event.target) || (event.target && event.target.id && (event.target.id !== campaign.id)))) {
        setStatusDropdownVisibility(false);
        setactiveIconVisibility(false);
      } else if (event.target.id === campaign.id) {
        event.stopPropagation();
        event.preventDefault();
        setStatusDropdownVisibility(true);
        setactiveIconVisibility(true);
      }
    }
    useEffect(() => {
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });
  }

  const [statusDropdownVisibility, setStatusDropdownVisibility] = useState(
    false,
  );
  const [activeIconVisibility, setactiveIconVisibility] = useState(
    false,
  );
  const conversationStatus = {
    value: 'EDIT'
  };
  const handleStatusChange = (status, id) => {
    console.log(status, id);
    if (status === 'edit') {
      editCampaign(id);
    }
    if (status === 'Delete') {
      deleteCampaign(id);
    }
    if (status === 'report') {
      downloadReport(id);
    }
  };
  const clickCampaign = (event, campaign) => {
    if (!statusDropdownVisibility) {
      editCampaign(campaign.id);
    }
    console.log(event.target, statusDropdownVisibility);
  };
  const getStatusData = () => {
    if (getStatusText(campaign.status).showdropdown) {
      return (<div className="data">
        {campaign.status !== 'CREATED' ?
          (
            <>
              <span>{getStatusText(campaign.status).value}</span> {moment(campaign.updated_time).tz(timezone).format('MMM D, hh:mm a')}
            </>
          )
          : (
            <>
              <span>{getStatusText(campaign.status).value}</span> {moment(campaign.created_time).tz(timezone).format('MMM D, hh:mm a')}
            </>
          )
        }
      </div>);
    } else {
      return (<div className="data">
        <span className="sending">{getStatusText(campaign.status).value}</span> ({campaign.messages_sent} out of {campaign.contacts_count} completed)
      </div>);
    }
  };
  return (
    <div className='campaign' style={{ backgroundColor: (!getStatusText(campaign.status).showdropdown) ? ' #F5F6F8' : '#FFFF' }} onClick={(event) => clickCampaign(event, campaign)}>
      <div className="campaign_status">
        <div className="title">
          <span className="name">{campaign.name}</span>
          {campaign.status === 'CREATED' &&
            <span className="draft">
              DRAFT
            </span>
          }
        </div>
        {getStatusData()}
      </div>
      {getStatusText(campaign.status).showdropdown &&
        <div className="campaign_message">
          <div className="title">
            {(campaign.messages_sent > 0) ? campaign.messages_sent : '-'}
          </div>
          <div className="data">
            message(s) sent
          </div>
        </div>
      }
      <div className={classnames('menu', { 'border-icon': activeIconVisibility, })}>
        {getStatusText(campaign.status).showdropdown &&
          <a
            href="#"
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              setStatusDropdownVisibility(true, campaign.id);
            }}
          >
            <i id={campaign.id} class="material-icons">more_horiz</i>
          </a>
        }
        <StatusSelectDropdown
          visibility={statusDropdownVisibility}
          position="tl"
          onVisibilityChange={(visibility) => {
            setStatusDropdownVisibility(visibility, campaign.id);
            setactiveIconVisibility(visibility);
          }}
          selectedOption={conversationStatus.value}
          className="menu__dropdown"
          onChange={(event) => { handleStatusChange(event, campaign.id); }}
          dropdownMenu={getStatusText(campaign.status).dropdown}
        />
      </div>
    </div>
  );
};

export default Campaign;
